export const EURASIA36_MERCHANT = '16';

export const eurasia36Verify = (param?: string) => {
  if (param) {
    return `/${EURASIA36_MERCHANT}/verify/${param}` as const;
  }
  return 'verify/:id' as const;
};

export const eurasia36VerifySuccess = (param?: string) => {
  if (param) {
    return `/${EURASIA36_MERCHANT}/verify/success/${param}` as const;
  }
  return 'verify/success/:id' as const;
};

export const eurasia36VerifyFailed = (param?: string) => {
  if (param) {
    return `/${EURASIA36_MERCHANT}/verify/failed/${param}` as const;
  }
  return 'verify/failed/:id' as const;
};

export const eurasia36Pay = (param?: string) => {
  if (param) {
    return `/${EURASIA36_MERCHANT}/pay/${param}`;
  }
  return 'pay/:id' as const;
};

export const eurasia36PaySuccess = (param?: string) => {
  if (param) {
    return `/${EURASIA36_MERCHANT}/pay/success/${param}` as const;
  }
  return 'pay/success/:id' as const;
};

export const eurasia36PayFailed = (param?: string) => {
  if (param) {
    return `/${EURASIA36_MERCHANT}/pay/failed/${param}` as const;
  }
  return 'pay/failed/:id' as const;
};
